<script>
 import { tick, onMount } from "svelte";
 import {
     current_episode,
     episode_desc,
     episodes,
     paused,
     current_time,
     not_found,
     static_page,
 } from "../stores/store.js";

 export let url;
 
 $: plainUrl = url.split("?")[0];
 $: slug = decodeURI(plainUrl);

 $: number = ($episodes && $episodes.length > 0) ? $episodes[$current_episode]?.number : null;

 function scrollToTop() {
     let isMobile = window.matchMedia(
         "only screen and (max-width: 760px)",
     ).matches;

     if (isMobile) {
         document
             .getElementById("audio-player")
         ?.scrollIntoView({ behavior: "smooth" });
     } else {
         window.scrollTo({ top: 0, behavior: "smooth" });
     }
 }

 $: if ($episodes && $episodes.length > 0) {
     update(slug);
 }

 async function update(currentSlug) {
     if (currentSlug === "/merch") {
         $static_page = "merch";
         $not_found = false;
         $episode_desc = false;
         return;
     }

     if (currentSlug === "/drops") {
         $static_page = "drops";
         $not_found = false;
         $episode_desc = false;
         return;
     }

     if (currentSlug === "/radio") {
         $static_page = "radio";
         $not_found = false;
         $episode_desc = false;
         return;
     }

     $static_page = "";
     if (currentSlug !== "/") {
         // Incorporating your robust URL matching logic (stripping slashes)
         let cleanSlug = currentSlug.replace(/^\/+/, '').toLowerCase();
         
         let episode_id = $episodes.findIndex(
             (ep) => ep.link.replace(/^\/+/, '').toLowerCase() === cleanSlug
         );

         if (episode_id !== -1) {
             $current_episode = episode_id;
             $episode_desc = true;
             $paused = true;
             await tick();
             $not_found = false;
         } else {
             $current_episode = 0;
             $not_found = true;
         }
         scrollToTop();
     } else {
         $episode_desc = false;
         $not_found = false;
     }
 }
</script>
